/* eslint-disable */
import Vue from 'vue'
import Router from 'vue-router'

import Home from '@/components/Home'
import AdminDashboard from '@/components/AdminDashboard'
import ErrorComponent from '@/components/Error';
import UnsubscribeComponent from '@/components/Unsubscribe';

Vue.use(Router)

export default new Router({
  mode: 'history',
  base: '/',
  routes: [
    {
      path: '/',
      name: 'Home',
      component: Home
    },
    {
      path: '/opt-out',
      name: 'Unsubscribe',
      component: UnsubscribeComponent
    },
    {
      path: '/admin/dashboard',
      name: 'AdminDashboard',
      component: AdminDashboard
    },
    {
      path: '/error', component: ErrorComponent
    }
  ]
})
